import { useEffect, useState, useContext, useMemo } from "react";
import {
  Modal,
  Paper,
  Typography,
  Box,
  Button,
  IconButton,
  CircularProgress
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContext } from "../../providers/ToastProvider";
import { DrawerContext } from "../../providers/DrawerProvider";
import { useTheme } from "@mui/material/styles";
import ReportService from "../../services/ReportService";

const DownloaderReport = ({ open, handleClose, reportType }) => {
  const { setShowToast, setToastMessage } = useContext(ToastContext);
  const [loading, setLoading] = useState(true)
  const [url, setUrl] = useState("")
  const { drawerOpen } = useContext(DrawerContext);
  const reportService = useMemo(() => new ReportService(), []);
  const theme = useTheme();

  const getReport = async (reportId) => {
    try {
      if (!reportId) {
        throw new Error("reportId is null")
      }

      const res = await reportService.get(reportId)

      const url = res.data.result?.preSignedUrl

      if (!url) {
        setTimeout(() => getReport(reportId), 3000)
        return
      }

      setUrl(url)
      setLoading(false)

    } catch (error) {
      setToastMessage([
        {
          severity: "error",
          primary: "Hubo un error generando este reporte",
        },
      ]);
      setShowToast(true);
      handleClose()
    }
  }

  const createReport = async (data) => {
    try {
      const payload = {
        reportType
      }

      const res = await reportService.create(payload)

      getReport(res.data.result.id)

    } catch (error) {
      setToastMessage([
        {
          severity: "error",
          primary: "Hubo un error generando este reporte",
        },
      ]);
      setShowToast(true);
      handleClose()
    }
  };

  const getTitle = useMemo(() => {
    switch(reportType) {
      case "AvailableProductReport":
        return "Reporte de productos disponibles"

      default:
        return "Reporte"
    }
  })

  const classes = {
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      left: drawerOpen ? theme.drawerWidth : 0,

      "& .MuiModal-backdrop": {
        left: drawerOpen ? theme.drawerWidth : 0,
      },
    },
    paper: {
      width: "90%",
      maxWidth: 400,
      textAlign: "center",
      position: "relative",
      top: -50,
      pt: 3,
      pb: 5,
      px: 6,
    },
    actions: {
      display: "flex",
      justifyContent: "center",
      gap: 2,
    },
    closeButton: {
      position: "absolute",
      top: 2,
      right: 8
    }
  };

  useEffect(() => {
    if (open) {
      createReport()
    }
  }, [open])

  return (
    <Modal open={open} sx={classes.root}>
      <Paper sx={classes.paper}>
        <Typography variant="h6" component="h3" mb={3}>
          <Box component={FontAwesomeIcon} icon="file-csv" mr={2} />{" "}
          {getTitle}
        </Typography>
        <IconButton variant="contained" onClick={handleClose} sx={classes.closeButton}>
          <Box
            component={FontAwesomeIcon}
            icon="xmark"
            fontSize="1rem"
            ml="8px"
          />
        </IconButton>
        <Box mt={5} sx={classes.actions}>
          <Button href={url} target="_blank" type="submit" variant="contained" fullWidth disabled={loading}>
            {
              loading ? 
                <>
                  Cargando reporte
                  <CircularProgress
                    sx={{ ml: 1 }}
                    thickness={3}
                    size={20}
                    color="inherit"
                  />
                </> :
                <>
                  Descargar reporte
                  <Box
                    component={FontAwesomeIcon}
                    icon="file-arrow-down"
                    fontSize="1rem"
                    ml="8px"
                  />
                </>
            }            
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

export default DownloaderReport;
